import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationKindEnum } from '@zaoblako/shared/modules/notification/enums/notification.kind.enum';
import { LkEuNotificationListComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/notification-panel/notification-list/lk-eu-notification-list.component';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';

@Component({
  selector: 'crm-lk-eu-notification-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SidebarModule,
    ButtonModule,
    SharedModule,
    LkEuNotificationListComponent,
    SelectButtonModule
  ],
  templateUrl: './lk-eu-notification-sidebar.component.html',
  styleUrls: ['./lk-eu-notification-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LkEuNotificationSidebarComponent {
  @Input() public position = 'right';

  @Input() public isShow = false;
  @Output() public isShowChange = new EventEmitter<boolean>();

  @ViewChild(LkEuNotificationListComponent, { static: false }) public notificationRef: LkEuNotificationListComponent;

  public informerTypeOptions: { icon: string; label: string; value: NotificationKindEnum }[] = [
    { icon: 'pi pi-user', label: 'Личные', value: NotificationKindEnum.HELPDESK },
    { icon: 'pi pi-question-circle', label: 'Заявки', value: NotificationKindEnum.PERSONAL }
  ];

  public selectedInformerType: NotificationKindEnum.HELPDESK | NotificationKindEnum.PERSONAL =
    NotificationKindEnum.HELPDESK;

  public get NotificationKindEnum() {
    return NotificationKindEnum;
  }
}
